import { TBooleanInNumber, TTranslate } from 'src/types/main';
import { DAYS_OF_WEEK } from '~/constants/dateTime';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import { DELIVERY_TYPE } from '~/constants/deliveryTypes';

export type TCashbackDate = Date | string | undefined | null;

export type TCashback = {
  id: number;
  priority: number;
  created_at: Date | null;
  delayed_credit: string;
  delayed_credit_period: number;
  deleted_at: Date | null;
  description: TTranslate;
  branches: { id: number; name: TTranslate }[];
  max_cashback: number;
  name: TTranslate;
  percent: number;
  order_types: DELIVERY_TYPE[];
  // time
  start_time: Date | undefined;
  end_time: Date | undefined;
  // date
  start_day: Date | undefined;
  end_day: Date | undefined;
  days_of_week: DAYS_OF_WEEK[];
  //
  updated_at: Date | null;
  validity: string;
  validity_period: number;
  state: TBooleanInNumber;
};

export type IEditCashback = Omit<TCashback, 'delayed_credit_period' | 'max_cashback' | 'percent' | 'validity_period' | 'priority'> & {
  delayed_credit_period: string;
  max_cashback: string;
  percent: string;
  validity_period: string;
  all_day: boolean | undefined;
  state: TBooleanInNumber;
  highest_priority: TBooleanInNumber;
  isActiveLimitReached: boolean;
  isExpired: boolean;
  branchesSelection: BRANCHES_SELECTION;
};

export enum BRANCHES_SELECTION {
  ALL = 'all',
  INCLUDED = 'include',
}

export interface ICashbackFilter {
  search?: string;
  statusOption?: IPickerOption;
}

export enum CASHBACK_DISCOUNT_TYPE {
  AMOUNT = 'a',
  PERCENTAGE = 'p',
}

export enum CASHBACK_APPLICABILITY {
  ALL,
  ORDERS,
}

export enum CASHBACK_MENU {
  ALL,
  INCLUDE,
  EXCLUDE,
}

export interface ICashbackValidationErrors {
  nameEn: string | null;
  nameAr: string | null;
  descriptionEn: string | null;
  descriptionAr: string | null;
  date: string | null;
  percent: string | null;
  balanceValidityPeriod: string | null;
  orderTypes: string | null;
}
